import { selectDay, selectDayForHotel } from '../actions/date-select-actions';
import {
  getMonthData,
  getPreferDirects,
  getSelectedHotelCheckInDate,
  getSelectedHotelCheckInMonth,
  getSelectedHotelCheckOutDate,
  getSelectedHotelCheckOutMonth,
  getSelectedInboundDate,
  getSelectedInboundMonth,
  getSelectedOutboundDate,
  getSelectedOutboundMonth,
  isReturn,
} from '../selectors';

import * as constants from './constants/dataTypeConstants';
import dateSelectionValidators from './dateSelectionValidators';

import type { State } from '../selectors/types';
import type { Dispatch } from 'redux';

const ensureValidDates = (state: State, dispatch: Dispatch) => {
  const preferDirects = getPreferDirects(state);
  const gridData = getMonthData(state);
  const outboundDate = getSelectedOutboundDate(state);
  const outboundMonth = getSelectedOutboundMonth(state);
  const inboundDate = getSelectedInboundDate(state);
  const inboundMonth = getSelectedInboundMonth(state);
  const returnTrip = isReturn(state);

  const validatedDates = dateSelectionValidators.getValidDates(
    outboundDate,
    outboundMonth,
    inboundDate,
    inboundMonth,
    gridData,
    preferDirects,
    returnTrip,
  );

  if (validatedDates.changed) {
    dispatch(
      selectDay(
        validatedDates.selectedOutbound.getDate(),
        constants.OUTBOUND_DIRECTION,
        constants.AUTOMATED_SOURCE,
      ),
    );
    if (returnTrip && validatedDates.selectedInbound) {
      dispatch(
        selectDay(
          validatedDates.selectedInbound.getDate(),
          constants.INBOUND_DIRECTION,
          constants.AUTOMATED_SOURCE,
        ),
      );
    }
  }
};

const ensureValidHotelDates = (state: State, dispatch: Dispatch) => {
  const checkInDate = getSelectedHotelCheckInDate(state);
  const checkOutDate = getSelectedHotelCheckOutDate(state);
  const checkInMonth = getSelectedHotelCheckInMonth(state);
  const checkOutMonth = getSelectedHotelCheckOutMonth(state);

  const hotelValidatedDates = dateSelectionValidators.getValidHotelDates(
    checkInDate,
    checkOutDate,
    checkInMonth,
    checkOutMonth,
  );

  if (hotelValidatedDates.changed) {
    dispatch(
      selectDayForHotel(
        hotelValidatedDates.selectedCheckIn.getDate(),
        constants.OUTBOUND_DIRECTION,
        constants.AUTOMATED_SOURCE,
      ),
    );
    if (hotelValidatedDates.selectedCheckOut) {
      dispatch(
        selectDayForHotel(
          hotelValidatedDates.selectedCheckOut.getDate(),
          constants.INBOUND_DIRECTION,
          constants.AUTOMATED_SOURCE,
        ),
      );
    }
  }
};

export default { ensureValidDates, ensureValidHotelDates };
